export const OVERLAY_SOURCE_ID = 'meeting-room-availability';
export const OVERLAY_FILL_LAYER_ID = `${OVERLAY_SOURCE_ID}-fill`;
export const OVERLAY_SYMBOL_LAYER_ID = `${OVERLAY_SOURCE_ID}-symbol`;
const STATUS_ICON_PREFIX = `${OVERLAY_SOURCE_ID}-icon-`;
export const MEETING_ROOM_ENDPOINT_PATH = '/room-statuses';

export const statusStyles = {
  unavailable_and_occupied: {
    iconUrl:
      'https://media.mapsindoors.com/4ea2b1501eb34faeabeeff7b/media/Meeting%20room%203%20-%20In%20use.png',
    fillColor: '#ef5675',
  },
  unavailable_and_free: {
    iconUrl:
      'https://media.mapsindoors.com/4ea2b1501eb34faeabeeff7b/media/Meeting%20room%203%20-%20Booked.png',
    fillColor: '#fcd40c',
  },
  available_and_occupied: {
    iconUrl:
      'https://media.mapsindoors.com/4ea2b1501eb34faeabeeff7b/media/Meeting%20room%203%20-%20Free.png',
    fillColor: '#7bdcb5',
  },
  available_and_free: {
    iconUrl:
      'https://media.mapsindoors.com/4ea2b1501eb34faeabeeff7b/media/Meeting%20room%203%20-%20Free.png',
    fillColor: '#17B169',
  },
} as const;

export type StatusKey = keyof typeof statusStyles;

export const statusIconId = (status: StatusKey) => `${STATUS_ICON_PREFIX}${status}`;

export type MatchExpression = readonly ['match', readonly ['get', 'status'], ...string[]];
